import { QueryData } from "@supabase/supabase-js";
import { queryOptions } from "@tanstack/react-query";
import { IterableElement } from "type-fest";

import { supabase } from "@/lib/supabase";

export type OrderJob = IterableElement<QueryData<typeof orderJobsQuery>>;

const orderJobsQuery = supabase
  .from("Job")
  .select("*, customer:Customer(id,name,billing), customFieldValues:JobCustomFieldValue(*)")
  .eq("deleted", false)
  .or("number.like.SO-____,number.like.DO-____,number.like.RO-____")
  .order("id", { ascending: false })
  .throwOnError();

export const orderJobsQueryOptions = queryOptions({
  queryKey: ["Job", "order"],
  queryFn: async () => (await orderJobsQuery).data,
});
